export default __webpack_public_path__ + "static/media/ET.dad524f6.svg";